import client from './client'

const apiBasePath = '/api/account/entry/'

export default {
  register: entryForm => client.post(apiBasePath + 'register', entryForm),
  entryFileUploadUrl: () => client.get(apiBasePath + 'entry-file-upload-url')
}
